<template>
  <section class="loading-container">
    <img :src='require("@/assets/images/ajax-loader.gif")' class="img-fluid bg-img" />
  </section>
</template>
<script>

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      globalError: "getGlobalError",
      appUserAuthed: 'auth/appUserAuthed',
      getAccessToken: 'auth/getAccessToken',
    })
  },
  data() {
    return {
      logintitle: "Login",
      errors: [],
      user: null,
      password: null
    };
  },
  methods:{
    async getWebAccount() {
        var {dispatch} = this.$store
        await dispatch('auth/getAccount', {register_it: 0})
        await dispatch('cart/loadPagesProducts');
        await dispatch('cart/loadShoppingCart');
        setTimeout(() => {
          this.$router.push({name: 'shop'})  
        }, 2500);
    },
  },
  watch: {
    getAccessToken: async function() {
      this.getWebAccount();
    }
  },
};
</script>
